export default __webpack_public_path__ + "static/logo-pcmag-9b35305f60a5098a03e4d98c809f2783.png";